/**
 * Les pièces qui ont une image peinte.
 *
 * **Généré depuis le disque par `scripts/indexer-icones.mjs` : ne pas éditer à
 * la main.** Une liste tenue à la main peut promettre une image qui n'est pas
 * là ; celle-ci ne le peut pas, puisqu'elle EST la liste des fichiers.
 *
 * Deux formes de clé :
 *
 *   - `<code du modèle>` — une pièce précise, toujours valable ;
 *   - `<famille>-<palier>` — une famille à une rareté, **et seulement pour de
 *     l'équipement**. Les matériaux portent une famille de remplissage, la
 *     colonne étant obligatoire, si bien que « Ferraille » est rangée en
 *     `masse` : sans cette réserve, elle prenait l'icône d'une masse. Trouvé
 *     par Enzo en regardant ses sacs.
 */
export const ICONES_PEINTES = new Set<string>([
  'dague-commun',
  'dague-epique',
  'dague-fin',
  'dague-legendaire',
  'dague-mythique',
  'dague-rare',
  'dague-standard',
  'dague-ultime',
  'dague_ultime_admin',
  'epee-commun',
  'epee-epique',
  'epee-fin',
  'epee-mythique',
  'epee-rare',
  'epee-standard',
  'gantelets-commun',
  'gantelets-epique',
  'gantelets-fin',
  'gantelets-legendaire',
  'gantelets-mythique',
  'gantelets-rare',
  'gantelets-standard',
  'hache-commun',
  'hache-epique',
  'hache-fin',
  'hache-rare',
  'hache-standard',
  'heaume-commun',
  'heaume-epique',
  'heaume-fin',
  'heaume-mythique',
  'heaume-rare',
  'heaume-standard',
  'masse-commun',
  'masse-epique',
  'masse-fin',
  'masse-mythique',
  'masse-rare',
  'masse-standard',
])
